import styled, { css } from 'styled-components';
import { FlexColumn, FlexRow } from 'styles/Layout';
import { media } from 'styles/Mixins';
import { PrimaryButton } from 'styles/Buttons';
import Select from 'react-select';

export const TenantReportContainer = styled(FlexColumn)`
  flex: 1;
  align-items: center;
  ${media.sm`
    padding-top: 60px;
    background: #F8F8F8;
  `}
`;

export const TenantReportContainerInner = styled(FlexColumn)`
  width: 300px;
  align-items: center;
`;

export const TenantReportHeading = styled.h1`
  color: #4a4a4a;
  font-size: 20px;
  font-weight: bold;
  text-align: center;
`;

export const ValidThrough = styled.p`
  color: #4a4a4a;
  text-align: center;
  font-size: 14px;
`;

export const Paragraph = styled.p`
  color: black;
  text-align: center;
  font-size: 14px;
  margin-bottom: 16px;
`;

export const TenantActionContainer = styled(FlexColumn)`
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.12);
  padding: 10px;
  align-items: center;

  ${({ approved }) =>
    !approved &&
    css`
      border: 3px solid #8ad752;
      border-radius: 6px;
      margin: 4px;

      ${media.sm`
        border-radius: 0;
        margin: 0;
      `}
    `}

  ${media.sm`
    padding: 16px;
    justify-content: space-between;
    flex-direction: row;
  `}

  ${media.md`
    padding: 24px 89px;
    justify-content: space-between;
    flex-direction: row;
  `}
`;

export const EvaluationResult = styled.p`
  color: #9d9d9d;
  text-align: center;
  font-size: 12px;
  font-weight: bold;
  margin-bottom: 10px;

  & a {
    color: #9673ff;
  }

  ${media.md`
    font-weight: normal;
    text-align: left;
    font-size: 14px;
    max-width: 350px;
    margin-bottom: 0;
  `}
`;

export const PriceOptions = styled.p`
  font-size: 16px;
  color: #000000;
  font-weight: bold;
  margin-bottom: 0;

  ${media.sm`
    font-size: 20px;
  `}
`;

export const SuccessOverlay = styled.div`
  padding: 60px;
  background: white;
  flex: 1;
  align-items: center;
  display: flex;
  flex-direction: column;
`;

export const Circle = styled.div`
  width: 165px;
  height: 165px;
  border-radius: 50%;
  border: 4px solid #278c7e;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Icon = styled.span`
  font-size: 56px;
`;

export const OverlayHead = styled.h1`
  color: #4a4a4a;
  font-size: 32px;
  font-weight: bold;
`;

export const OverlayMessage = styled.p`
  font-size: 16px;
  color: #4a4a4a;
  text-align: center;
`;

export const SendWhatsAppBtn = styled(PrimaryButton)`
  font-size: 14px;

  ${media.sm`
    font-size: 16px;
  `}
`;

export const Wrapper = styled.div`
  margin-left: 15px;
  width: 270px;
`;

export const AutomateCheckContainer = styled.div`
  display: inline-block;
  margin: 10px 0;
  width: 100%;
  padding: 12px 10px 6px 10px;
`;

export const StyledValidatedCheckbox = styled(FlexRow)`
  min-height: 18px;
  width: 100%;
  margin-bottom: 3px;
`;

export const ContainterBox = styled.div`
  min-height: 18px;
`;

export const LabelBox = styled.div`
  margin-left: 13px;
  font-size: 12px;
  line-height: 19px;
  text-align: initial;
`;

export const StylesSelect = styled(Select)`
  display: inline-block;
  margin: 10px 0 20px 0;
  font-size: 16px;
  height: 35px;
  width: 270px;
  border-radius: 2px;
  background-color: #ffffff;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.5);
  border-style: none;
`;
